module.exports = __webpack_public_path__ + "img/iconSystemRolePermission-gray.29c53583.svg";